export class BulletinEventService {
  constructor(fetchData) {
    this.fetchData = fetchData;
  }

  async getEvents(bulletinId) {
    return await this.fetchData({
      url:    `ebulletin/bulletins/${bulletinId}/events`,
      method: 'GET',
    });
  }

  async getAllEvents(bulletinId) {
    return await this.fetchData({
      url:    `ebulletin/bulletins/${bulletinId}/events/all`,
      method: 'GET',
    });
  }

  async createEvent(bulletinId, data) {
    return await this.fetchData({
      url:    `ebulletin/bulletins/${bulletinId}/events`,
      method: 'POST',
      data,
    });
  }

  async updateEvent(bulletinId, id, data) {
    return await this.fetchData({
      url:    `ebulletin/bulletins/${bulletinId}/events/${id}`,
      method: 'PUT',
      data,
    });
  }

  async deleteEvent(bulletinId, id) {
    return await this.fetchData({
      url:    `ebulletin/bulletins/${bulletinId}/events/${id}`,
      method: 'DELETE',
    });
  }

  /**
   * Upload a CSV or XLSX file for bulk import.
   * @param {number} bulletinId
   * @param {File}   file  - the selected File object
   */
  async importEvents(bulletinId, file) {
    const formData = new FormData();
    formData.append('file', file);
    // No Content-Type header needed — useAxios detects FormData and lets
    // axios set "multipart/form-data; boundary=..." automatically.
    return await this.fetchData({
      url:    `ebulletin/bulletins/${bulletinId}/events/import`,
      method: 'POST',
      data:   formData,
    });
  }
}
